export const submitBulkAdminRecommendationMutation = `mutation SubmitBulkAdminRecommendation($input: BulkAdminRecommendationInput!) {
  submitBulkAdminRecommendation(input: $input) {
      status
      details
      error {
          message
          date
      }
  }
}`;
